// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KN57","question":"styles_question__3DA6i","description":"styles_description__3DOpp"};